<res-base-modal [modalTitle]="title" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [modalContainerAutomationId]="modalContainerAutomationId" [primaryButtonLabel]="okBtnText"
    (primaryButtonActionEmt)="closeModal(true, okBtnText)" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    [isPrimaryButtonHidden]="!okBtnText" [secondaryButtonLabel]="cancelBtnText" (closeButtonActionEmt)="closeButton()"
    [middleButtonTemplate]="thirdButtonTemplate" [isCloseButtonVisible]="closeButtonVisible">

    <div class="message-icon" *ngIf="iconClassName && iconClassName != 'del'">
        <i class="fa" [ngClass]="iconClassName" [attr.data-automation-id]="modalAutomationId + '-icon'"></i>
    </div>
    <div *ngIf="!contentTemplate && !isMessageWithCounter && !isDeleteProject"
        [attr.data-automation-id]="modalAutomationId + '-message-label'" class="message" [innerText]="message"></div>
    <div *ngIf="isMessageWithCounter || isDeleteProject" [attr.data-automation-id]="modalAutomationId + '-message-label'" class="message"
        [innerHTML]="message"></div>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    <ng-template #thirdButtonTemplate>
        <button *ngIf="secondBtnText" type="button" [attr.data-automation-id]="modalAutomationId + '-third-button'"
            class="secondary-button" (click)="closeModal(true, secondBtnText)">{{ secondBtnText }}</button>
    </ng-template>

</res-base-modal>